import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgCloseCircle = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ref, ...props, children: [
  /* @__PURE__ */ jsx("circle", { cx: 6, cy: 6, r: 6, fill: "#DCDCDC" }),
  /* @__PURE__ */ jsx("path", { d: "M4 4L8 8", stroke: "white" }),
  /* @__PURE__ */ jsx("path", { d: "M8 4L4 8", stroke: "white" })
] });
const ForwardRef = forwardRef(SvgCloseCircle);
export { ForwardRef as ReactComponent };
